import React, { useEffect, useState } from 'react';
import hands from '../images/hands.svg';

function ContactPopup({popup, updateValue}) {
  const [isOpen, setIsOpen] = useState(popup);
  const [formData, setFormData] = useState({
    Name: '',
    EmailId: '',
    MobileNo: '',
    Description:''
  });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  
  useEffect(() => {
    setIsOpen(popup);
  }, [popup]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Validate form data
  const validate = () => {
    const newErrors = {};
    const phonePattern = /^[0-9]{10}$/;
    if (formData.Name.trim() === '') {
      newErrors.Name = 'Name is required';
    } else if (formData.Name.length < 5) {
      newErrors.Name = 'Name must be at least 5 characters';
    }
    if (formData.EmailId.trim() === '') {
      newErrors.EmailId = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.EmailId)) {
      newErrors.EmailId = 'Email is invalid';
    }
    if (formData.MobileNo.trim() === '') {
      newErrors.MobileNo = 'MobileNo is required';
    } else if (!phonePattern.test(formData.MobileNo.trim())) {
      newErrors.MobileNo = 'Mobile Number must be 10 digits';
    }
    if (formData.Description.trim() === '') {
      newErrors.Description = 'Message is required';
    } else if (formData.Description.length < 5) {
      newErrors.Description = 'Message must be at least 5 characters';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setIsDisabled(true)
      const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

      let eventURI = process.env.REACT_APP_API_URL +"/Contact/CreateContact";
      fetch(eventURI ,  {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body:  JSON.stringify(formData),
        redirect: "follow"
      })
      .then((response) => response.text())
      .then((result) => setSuccess(true))
      .catch((error) => console.error(error));
      
    }
  };

  const closeModal = () => {
    updateValue(false);
    setSuccess(false)
  };

  return (
    <div>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 ">
            <div className="relative bg-white rounded shadow-lg w-[90vw] max-w-2xl p-6">
            <button
                className="absolute top-3 right-5 text-4xl"
                onClick={()=>closeModal()}
            >&times;
            </button>
            {!success && (
              <div>
                  <div className='pb-3'>
                      <h2 className='text-2xl headertitle'>Love to Hear From You!</h2>
                      <div className="inline-flex items-center">
                        <p className='text-2xl headertitle'>Get in Touch.</p> 
                        <img src={hands} alt="Image" className="w-8 h-8 mr-2" /> 
                      </div>
                  </div>
                  <form onSubmit={handleSubmit} className="space-y-3 pt-4 ">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {/* Column 1 */}
                      <div>
                      <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 pl-1">Name</label>
                      <input
                          type="text"
                          id="Name"
                          name="Name"
                          value={formData.Name}
                          onChange={handleChange}
                          className="bg-input-gray mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          placeholder="John"
                      />
                      {errors.Name && (
                        <p className="text-red-500 text-sm mt-1">{errors.Name}</p>
                      )}
                      </div>
                      <div>
                      <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 pl-1">Email</label>
                      <input
                          type="email"
                          id="EmailId"
                          name="EmailId"
                          value={formData.EmailId}
                          onChange={handleChange}
                          className="bg-input-gray mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          placeholder="john.doe@example.com"
                      />
                      {errors.EmailId && (
                        <p className="text-red-500 text-sm mt-1">{errors.EmailId}</p>
                      )}
                      </div>
                      </div>
                      {/* Column 2 */}
                      <div className="col-span-2">
                      <label htmlFor="MobileNo" className="block text-sm font-medium text-gray-700 pl-1">MobileNo</label>
                      <input
                          type="tel"
                          id="MobileNo"
                          name="MobileNo"
                          value={formData.MobileNo}
                          onChange={handleChange}
                          className="bg-input-gray mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          placeholder="MobileNo"
                      />
                      {errors.MobileNo && (
                        <p className="text-red-500 text-sm mt-1">{errors.MobileNo}</p>
                      )}
                      </div>
                      <div className="col-span-2">
                      <label htmlFor="Description" className="block text-sm font-medium text-gray-700 pl-1">Message</label>
                      <textarea
                          id="Description"
                          name="Description"
                          value={formData.Description}
                          onChange={handleChange}
                          placeholder=""
                          rows={3}
                          className="bg-input-gray mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          />
                      {errors.Description && (
                        <p className="text-red-500 text-sm mt-1">{errors.Description}</p>
                      )}
                      </div>
                      {/* Optional submit button spanning both columns */}
                      <div className="col-span-2">
                      <button
                          type="submit"
                          className="bg-red-600 text-white py-2 px-8 font-medium rounded-md shadow focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-75"
                          disabled={isDisabled}
                          >
                          Submit
                          </button>
                      </div>
    
                  </form>
              </div>
            )}
             {!!success && (
              <div>
                <p className='text-lg text-center pt-3'>We appreciate you sharing the details with us. Rest assured, we'll reach out to you shortly.</p>
              </div>
             )}
            </div>
        </div>
      )}
    </div>
  );
}

export default ContactPopup;